import { useState } from "react";
import styles from '../../css/payments/explore-pricing.module.css'
import { RewardsBGColors, PriceSavingColors } from "../../../Colors";
import DownArrow from '../../../images/down-arrow-circle.svg';
import { SelectPlanButton } from "./SelectPlanButton";

const YEARLY_PRICE_ID = process.env.REACT_APP_STRIPE_SUBSCRIPTION_PRICE_3;
const PRICE_AMOUNT = 192;

export const YearlyPriceTileDesktop = ({ timeOfDay }) => {
    return (
        <div className={styles.pricesContainerOuter} style={{ background: RewardsBGColors[timeOfDay], maxWidth: "18rem" }}>

            <div className={styles.pricesContainerInner}>
                <div className={styles.planHeader}>
                    <p className={styles.planTitle}>YEAR OF CLARITY</p>
                </div>
                <div className={styles.priceSection}>
                    <span className={styles.price}>${PRICE_AMOUNT}</span>
                    <span className={styles.billingCycle}>/ year</span>
                </div>
                <p className={styles.savings} style={{ color: PriceSavingColors[timeOfDay] }} >
                    Best value
                </p>
                <hr className={styles.divider} />
                <ul className={styles.featuresList}>
                    <li style={{ whiteSpace: "nowrap" }}>52 weeks of insights</li>
                    <li>12 monthly work big pictures</li>
                    <li>For committed achievers: all perks of growth plan for the intro price</li>
                </ul>
                <SelectPlanButton
                    extraStyles={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}
                    buttonText={'SELECT PLAN'}
                    stripePriceId={YEARLY_PRICE_ID}
                />
            </div>
        </div >
    )
}

export const YearlyPriceTileMobile = ({ timeOfDay }) => {
    const [showFeatures, setShowFeatures] = useState(false);

    const borderColor = timeOfDay !== 'night' ? RewardsBGColors[timeOfDay] : "linear-gradient(to bottom, rgb(87, 1, 83), rgb(11, 148, 161))";

    return (
        <div
            className={styles.pricesContainerMobile}
            style={{ background: borderColor }}
        >
            <div className={styles.pricesContainerInnerMobile}>
                <div
                    className={styles.headingSection}
                    onClick={() => setShowFeatures(!showFeatures)}
                >
                    <div className={styles.planDescriptionSectionMobile}>
                        <h2 className={styles.planTitleMobile}>YEAR OF CLARITY</h2>
                        <div className={styles.seeMoreTextSection}>
                            <p className={styles.seeMoreText}>Best value</p>
                            <img
                                src={DownArrow}
                                width={16}
                                // rotate image 180 degrees when dropdown is open
                                style={{ transform: showFeatures ? "rotate(180deg)" : "none", transition: "transform 0.5s" }}
                            />
                        </div>
                    </div>
                    <div className={styles.pricingSectionMobile}>
                        <h3 className={styles.priceMobile} style={{ fontSize: "2.05rem" }}>${PRICE_AMOUNT}</h3>
                        <hr className={styles.priceDividerMobile} />
                        <p className={styles.billingCycleMobile}>year</p>
                    </div>
                </div>
                <div
                    className={
                        showFeatures
                            ? `${styles.dropdownOpen}`
                            : `${styles.dropdownClosed}`
                    }
                >
                    <hr className={styles.divider} />
                    <ul className={`${styles.featuresList} ${styles.featuresListMobile}`}>
                        <li>52 weeks of insights</li>
                        <li>12 monthly work big pictures</li>
                        <li>All perks of growth plan for intro price</li>
                    </ul>
                    <SelectPlanButton
                        extraStyles={{ marginTop: 0, fontSize: "0.8rem" }}
                        buttonText={'SELECT PLAN'}
                        stripePriceId={YEARLY_PRICE_ID}
                    />
                </div>
            </div>
        </div>
    )
}